import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a6d66b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "btn btn-outline",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode("| "),
      _createVNode(_component_router_link, {
        class: "btn btn-outline",
        to: "/login"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Login")
        ]),
        _: 1
      }),
      _createTextVNode("| "),
      _createVNode(_component_router_link, {
        class: "btn btn-outline",
        to: "/register"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Registrar")
        ]),
        _: 1
      }),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-outline-danger btn-logout",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSignOut && _ctx.handleSignOut(...args)))
          }, "Sair da conta"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_view)
  ], 64))
}